import { Prisma } from "../../../";
import { setTypeOrderByStatement } from "./set";

export const variantTypeIncludeStatement = Prisma.validator<Prisma.VariantInclude>()({
  setCard: {
    include: {
      meta: true,
      set: true,
    },
  },
  reverse: {
    include: {
      setCard: {
        include: {
          meta: true,
          set: true,
        },
      },
      vMeta: true,
      artist: true,
    },
  },
  vMeta: true,
  artist: true,
});

export const variantTypeOrderByStatement: Prisma.VariantOrderByWithRelationInput = {
  setCard: {
    set: setTypeOrderByStatement,
  },
};
